import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost' | 'danger' | 'success';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  fullWidth?: boolean;
  children: React.ReactNode;
  techEffect?: boolean;
}
export function Button({
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  fullWidth = false,
  children,
  className = '',
  disabled,
  techEffect = true,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-md transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 relative overflow-hidden';
  const variantStyles = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500 shadow-sm',
    outline: 'border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 focus:ring-blue-500',
    ghost: 'text-gray-700 hover:bg-gray-100 focus:ring-gray-500',
    danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 shadow-sm',
    success: 'bg-green-600 text-white hover:bg-green-700 focus:ring-green-500 shadow-sm'
  };
  const sizeStyles = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-sm',
    lg: 'px-5 py-2.5 text-base'
  };
  const widthStyle = fullWidth ? 'w-full' : '';
  const disabledStyle = disabled || isLoading ? 'opacity-60 cursor-not-allowed' : '';
  const techEffectClass = techEffect && !disabled && !isLoading && variant === 'primary' ? 'tech-button' : '';
  return <button className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyle} ${disabledStyle} ${techEffectClass} ${className} group`} disabled={disabled || isLoading} {...props} data-id="element-48">
      {techEffect && variant === 'primary' && !disabled && !isLoading && <span className="absolute inset-0 overflow-hidden" data-id="element-49">
          <span className="absolute inset-0 rounded-md bg-gradient-to-r from-blue-500 to-indigo-600 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-50"></span>
        </span>}
      <span className="relative z-10 flex items-center" data-id="element-51">
        {isLoading && <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-52">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-53"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-54"></path>
          </svg>}
        {!isLoading && leftIcon && <span className="mr-2" data-id="element-55">{leftIcon}</span>}
        {children}
        {!isLoading && rightIcon && <span className="ml-2 transform group-hover:translate-x-0.5 transition-transform" data-id="element-56">
            {rightIcon}
          </span>}
      </span>
      <style jsx data-id="element-57">{`
        .tech-button::after {
          content: '';
          position: absolute;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.5);
          opacity: 0;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          transition:
            width 0.3s,
            height 0.3s,
            opacity 0.3s;
        }
        .tech-button:hover::after {
          width: 100%;
          height: 100%;
          opacity: 0.3;
        }
      `}</style>
    </button>;
}